$(document).ready(function () {
    var errorMsg = '';

    var _inputMail = $('#email');

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function submitForm() {
        var email = $('#email').val();
        var isEmail = validateEmail(email);

        if (email.length == 0) {
            errorMsg = trans('home.email_empty');
            $('.message-holder').html(errorMsg);
            $('.message-holder').addClass('error');
            return false;
        } else {
            errorMsg = '';
            $('.message-holder').html('');
            $('.message-holder').removeClass('error');
        }

        if (!isEmail) {
            errorMsg = trans('home.email_invalid');
            $('.message-holder').html(errorMsg);
            $('.message-holder').addClass('error');
            return false;
        } else {
            $('.message-holder').html('');
            $('.message-holder').removeClass('error');
            errorMsg = '';
        }

        $.ajax({
            url: '/submit-mail',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            data: {email: email},
            dataType: 'json',
            success: function (data) {
                if (data.errorMessage) {
                    errorMsg = data.errorMessage.email[0];
                    $('.message-holder').addClass('error');
                } else {
                    errorMsg = '';
                    $('.message-holder').removeClass('error');
                    _inputMail.val('');
                    $('.message-holder').html(trans('home.email_success'));
                }
                if (errorMsg) {
                    $('.message-holder').addClass('error');
                    $('.message-holder').html(errorMsg);
                } else {
                    $('.message-holder').removeClass('error');
                    _inputMail.val('');
                    $('.message-holder').html(trans('home.email_success'));
                }
            }
        });

    }

    $(document).on('click', '.button-holder', function () {
        submitForm();
    });

    $('#email').keypress(function (e) {
        if (e.which == 13) {
            $('.button-holder').trigger('click');
            return false;
        }
    });
});
